
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/7net",
      function () {
        return require("private-next-pages/cases/7net/index.tsx");
      }
    ]);
  